import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'

const urlModificarDocente = 'https://datosprofes.cpem46.edu.ar/Backendphp/modificar_docente.php'

const ModDocente = ({ docente, setSeccion, onGuardarExitoso }) => {
  const [apellido, setApellido] = useState('')
  const [nombre, setNombre] = useState('')
  const [dni, setDni] = useState('')
  const [email, setEmail] = useState('')
  const [titulo, setTitulo] = useState('')
  const [fechaNac, setFechaNac] = useState('')
  const [domicilio, setDomicilio] = useState('')
  const [telefono, setTelefono] = useState('')

  useEffect(() => {
    if (docente) {
      setApellido(docente.apellido)
      setNombre(docente.nombre)
      setDni(docente.dni)
      setEmail(docente.correo)
      setTitulo(docente.titulo)
      setFechaNac(docente.fecha_nac)
      setDomicilio(docente.domicilio)
      setTelefono(docente.telefono)
    }
  }, [docente])
  

  const guardarCambios = async (e) => {
    e.preventDefault()


    const datos = {
    id: docente.id,
      nombre,
      apellido,
      dni,
      correo: email,
      titulo,
      fecha_nac: fechaNac,
      domicilio,
      telefono,
    }

    try {
      await axios.post(urlModificarDocente, datos)

      Swal.fire({
        icon: 'success',
        title: 'Actualizado',
        text: 'Los datos del docente fueron actualizados correctamente.',
      }).then(() => {
        if (typeof onGuardarExitoso === 'function') {
          onGuardarExitoso()
        }
        setSeccion('')
      })
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron guardar los cambios.',
      })
    }
  }

  return (
    <div className="form-register">
      <h1>Modificar Docente</h1>
      <form onSubmit={guardarCambios}>
        <label htmlFor="apellido">Apellido</label>
        <div className="boxinput">
          <input
            type="text"
            id="apellido"
            className="controls"
            placeholder="Apellido"
            value={apellido}
            onChange={(e) => setApellido(e.target.value)}
            required
          />
        </div>

        <label htmlFor="nombre">Nombre</label>
        <div className="boxinput">
          <input
            type="text"
            id="nombre"
            className="controls"
            placeholder="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />
        </div>

        <label htmlFor="dni">DNI</label>
        <div className="boxinput">
          <input
            type="text"
            id="dni"
            className="controls"
            placeholder="DNI"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
            required
          />
        </div>

        <label htmlFor="email">Email</label>
        <div className="boxinput">
          <input
            type="email"
            id="email"
            className="controls"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <label htmlFor="titulo">Título</label>
        <div className="boxinput">
          <input
            type="text"
            id="titulo"
            className="controls"
            placeholder="Título profesional"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
          />
        </div>

        <label htmlFor="fechaNac">Fecha de Nacimiento</label>
        <div className="boxinput">
          <input
            type="date"
            id="fechaNac"
            className="controls"
            value={fechaNac}
            onChange={(e) => setFechaNac(e.target.value)}
          />
        </div>

        <label htmlFor="domicilio">Domicilio</label>
        <div className="boxinput">
          <input
            type="text"
            id="domicilio"
            className="controls"
            placeholder="Domicilio"
            value={domicilio}
            onChange={(e) => setDomicilio(e.target.value)}
          />
        </div>

        <label htmlFor="telefono">Teléfono</label>
        <div className="boxinput">
          <input
            type="text"
            id="telefono"
            className="controls"
            placeholder="Teléfono"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
          />
        </div>

        <div>
          <input className="botons" type="submit" value="Guardar Cambios" />
          <input className="botons" type="button" value="Cancelar" onClick={() => setSeccion('')} />
        </div>
      </form>
    </div>
  )
}

export default ModDocente
